'use strict';

var React = require('react');

var SvgBillingStatementDollarMajor = function SvgBillingStatementDollarMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.5 0h11a1.5 1.5 0 0 1 1.5 1.5v18.223a.2.2 0 0 1-.335.148l-1.662-1.513a.5.5 0 0 0-.673 0l-1.66 1.51a.5.5 0 0 1-.673 0l-1.66-1.51a.5.5 0 0 0-.674 0l-1.66 1.51a.5.5 0 0 1-.673 0l-1.66-1.51a.5.5 0 0 0-.673 0l-1.662 1.512a.2.2 0 0 1-.335-.147v-18.223a1.5 1.5 0 0 1 1.5-1.5zm4.207 11.293c.667.667 1.29.706 1.316.707.528 0 .977-.448.977-1 0-.646-.128-.751-1.243-1.03h-.001c-1.031-.258-2.756-.69-2.756-2.97a2.993 2.993 0 0 1 2-2.815v-.185a1 1 0 0 1 2 0v.2a4.51 4.51 0 0 1 1.707 1.093 1 1 0 0 1-1.414 1.414c-.667-.667-1.291-.706-1.317-.707-.528 0-.976.448-.976 1 0 .646.127.751 1.242 1.03h.002c1.03.258 2.756.69 2.756 2.97a2.995 2.995 0 0 1-2 2.815v.185a1 1 0 0 1-2 0v-.2a4.49 4.49 0 0 1-1.707-1.093 1 1 0 1 1 1.414-1.414z"
  }));
};

exports.SvgBillingStatementDollarMajor = SvgBillingStatementDollarMajor;
